
import { combineReducers } from 'redux';
import { productReducer } from './ProductsReducer';
import { reducer as formReducer } from 'redux-form';
import { MerchantsReducer } from './FetchMerchantsReducer';
import { BrandsReducer } from './BrandsReducer';
import { CategoryReducer } from './CategoryReducer';

const rootReducer = combineReducers({
    products: productReducer,
    form: formReducer,
    merchants: MerchantsReducer,
    brands: BrandsReducer,
    categories: CategoryReducer,
});

export default rootReducer;
